import { ColorSAP } from "../../ontego-ui";
import { styled } from "@mui/material";

const Styled = {};

Styled.DateGrid = styled("div")(() => ({
    display: 'grid',
    gridTemplateColumns: 'repeat(7, minmax(0, 1fr))',
    gridTemplateRows: 'auto',
    rowGap: 6,
    maxWidth: 250,
    maxHeight: 350
}));

Styled.NavigationBefore = styled("div")(() => ({
    position: 'absolute',
    left: 18,
    top: 16,
    opacity: 1,
    animation: `$fadeIn 300ms ease-in-out`,
}));

Styled.NavigationNext = styled("div")(() => ({
    position: 'absolute',
    right: 18,
    top: 16,
    opacity: 1,
    animation: `$fadeIn 300ms ease-in-out`
}));

Styled.DateGridItem = styled("div")(({ isBetween, isCheckIn, isCheckOut }) => ({
    position: 'relative',
    border: `2px solid ${isBetween ? ColorSAP.primary[10] : 'transparent'}`,
    background: (isBetween || isCheckIn || isCheckOut) ? ColorSAP.primary[10] : 'none',
    width: 32,
    height: 32,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

    borderTopLeftRadius: isCheckIn ? '50%' : '0%',
    borderBottomLeftRadius: isCheckIn ? '50%' : '0%',
    
    borderTopRightRadius: isCheckOut ? '50%' : '0%',
    borderBottomRightRadius: isCheckOut ? '50%' : '0%',
}));

Styled.DateGridItemSelectorStartBackground = styled("div")(() => ({
    backgroundColor: ColorSAP.primary[70],
    border: `2px solid ${ColorSAP.primary[70]}`,
    borderRadius: '50%',
    position: 'absolute',
    top: -2,
    left: -2,
    width: 32,
    height: 32,
    animation: `$zoomIn 120ms ease-in-out`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 2
}));

Styled.DateGridItemSelectorEndBackground = styled("div")(() => ({
    backgroundColor: '#fff',
    border: `2px solid ${ColorSAP.primary[70]}`,
    borderRadius: '50%',
    position: 'absolute',
    top: -2,
    left: -2,
    width: 32,
    height: 32,
    animation: `$zoomIn 120ms ease-in-out`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 2
}));

export default Styled;
